import _ from 'lodash';
import nxModule from 'nxModule';
import PrintService from 'print/PrintService';
import './passbook.style.less';
import templateUrl from './passbook.template.html';

const printService = new PrintService();

class Passbook {
  showPrinted = false;

  constructor($location, $filter, printsCache, modalPrintPreviewService, operationTableBuilder, http, command, $route, operationCodeFormatter) {
    this.$location = $location;
    this.$filter = $filter;
    this.modalPrintPreviewService = modalPrintPreviewService;
    this.tableBuilder = operationTableBuilder;
    this.http = http;
    this.command = command;
    this.$route = $route;
    this.operationCodeFormatter = operationCodeFormatter;
    this.prints = null;
    this.printLoader = printsCache.toPromise().then(prints => this.prints = prints);
  }

  $onInit() {
    this.reloadTableConfig();
  }

  $onChanges(changes) {
    if (changes.hasOwnProperty('product')) {
      this.reloadTableConfig();

      this.printLoader.then(_ => {
        this.hasSomeQualifiedPrints = this.renderablePrints && this.renderablePrints.some(print => this.isPrintQualified(print));
      });
    }
  }

  isPrintQualified(print) {
    if(!_.get(this.product, print.requires, true)) {
      return false;
    }

    if(this.prints === null) {
      throw new Error('Prints not read');
    }

    return this.modalPrintPreviewService.isReprintAvailable(this.prints, print.code);
  }

  toPrettyCode(printCode) {
    return this.$filter('prettyEnum')(printCode.replace(/TERM_DEPOSIT_|DEPOSIT_ACCOUNT_/gi, ''));
  }

  reloadTableConfig() {
    if (this.product) {
      this.passbookHistoryConfig = this.tableBuilder.buildNgTable({
        productId: this.product.id,
        status: ['PROCESSED', 'REVERTED'],
        passbookOnly: true,
        includePrintedInPassbook: this.showPrinted,
        printedOperationIds: this.passbookObj.printedOperationIds ?? [],
        passbookId: this.passbookObj.id
      });
    }
  }

  getOperationCode(operation) {
    return this.operationCodeFormatter.format(operation, this.product.id);
  }

  translate(operation) {
    const code = this.getOperationCode(operation);
    if(this.operationCodeFormatter.isCustomFeeApplyOnOperation(code)) {
      return operation.feeName;
    }
    return this.$filter('translate')(code, 'OPERATION_NAME');
  }

  transactionClicked(transaction, $event) {
    $event.stopPropagation();
    this.selectedTransactionId = transaction.id;
  }

  canPrint(operations) {
    return (operations || []).some(o => o.markedForPrintingInPassbook)
  }

  editNumber() {
    let productGroupPath;
    if (this.productGroup === 'TERM_DEPOSIT')
      productGroupPath = 'term-deposits';
    else if (this.productGroup === 'DEPOSIT_ACCOUNT')
      productGroupPath = 'accounts';
    this.$location.path(`/customer/${this.customerId}/${productGroupPath}/${this.product.id}/issue-passbook/edit`)
  }

  async printPassbook(data, printCode) {
    let operations = data.filter(o => o.markedForPrintingInPassbook);
    let operationIds = operations.map(o => o.id);
    const printProviderInput = {
      productId: this.product.id,
      operationIds: operationIds,
      startLine: this.passbookObj.nextLine
    };

    const passbook = this.passbookObj;
    const printedOperationIds = new Set(passbook.printedOperationIds || []);
    const reprintingOperation = operationIds.every(id => printedOperationIds.has(id));

    if(printCode === 'DEPOSIT_ACCOUNT_PASSBOOK' && reprintingOperation) {
        // this will automatically show print
        const result = await this.command.execute('ReprintDepositPassbook', {
          printInput: printProviderInput,
        }).toPromise();

        if (result && !result.approvalRequired) {
          this.$route.reload();
        }

        return;
    }

    const {printed} = await this.modalPrintPreviewService.showAsync({
      printDescription: {
        code: printCode,
        parameters: {
          'PRODUCT_DEFINITION': this.product.definitionId,
        }
      },
      printProviderInput,
    });

    if (printed) {
      // passbook can be printed from multiple places, so tagging operation as printed is in PrintService.handlePassbook
      this.$route.reload();
    }
  }
}

nxModule.component('passbook', {
  templateUrl,
  bindings: {
    renderablePrints: '<',
    product: '<',
    productGroup: '<',
    customerId: '<',
    passbookObj: '='
  },
  controller: Passbook
});
